module.exports = __webpack_public_path__ + "static/img/myDrive.fa51ed5.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/drive/logo/myDrive.svg
// module id = tvcl
// module chunks = 2